/*******************************************************************************
  DownloadRounds.js

  Author: Mark Duckworth; Advait; 

*******************************************************************************/

import React, { useState } from "react";
import { downloadFile } from "../apihelpers/apihelpers";
import { showNotification } from "./helper/notification";
import { validateDates } from "./helper/timeUtils";
import HeadingSubText from "./HeadingSubText";
import "../index.css";

/**
 * Component to download a usage report. Text fields for entering
 * the start and end dates, and a download button.
 */
function DownloadUsageReport(props) {
  const [datesEntered, setDatesEntered] = useState(false);

  /**
   * Click handler to perform the file download
   * @param {*} event
   */
  function doDownloadUsage(event) {
    event.preventDefault();
    const startDate = document.getElementById("usageStart").value;
    const endDate = document.getElementById("usageEnd").value;
    showNotification(true, "Generating report...", true);
    const api_path = `/usagereport?start=${startDate}&end=${endDate}`;

    // Create a filename for the saved file on the local machine
    let filename = `usage_report_${startDate}_to_${endDate}.csv`;
    downloadFile(api_path, filename);
    // Reset the date fields after download
    document.getElementById("usageStart").value = "";
    document.getElementById("usageEnd").value = "";
    setDatesEntered(false);
  }

  /**
   * Handler to check if both dates are entered and enable/disable the download button
   */
  function handleDateChange() {
    const startDate = document.getElementById("usageStart").value;
    const endDate = document.getElementById("usageEnd").value;
    setDatesEntered(validateDates(startDate, endDate, true, 92));
  }
  return (
    <div className="individualContainer">
      <table className="individualContainerTable">
        <tbody>
          <tr>
            <td className="individualContainerTitleColumn" valign="top">
              <h4 className="individualContainerTitleHeading">Download Usage Report</h4>
              <HeadingSubText text="End date must be within 92 days of start date" />
            </td>
            <td>
              <table>
                <tbody>
                  <tr>
                    <th style={{ paddingTop: "5px" }}>Start Date</th>
                    <th style={{ paddingTop: "5px" }}>End Date</th>
                  </tr>
                  <tr>
                    <td>
                      <input
                        style={{ width: "120px", marginRight: "15px", paddingLeft: "5px" }}
                        id="usageStart"
                        type="text"
                        required
                        minLength="10"
                        maxLength="10"
                        placeholder="YYYY-MM-DD"
                        onChange={handleDateChange}
                      />
                    </td>
                    <td>
                      <input
                        style={{ width: "120px", paddingLeft: "5px" }}
                        id="usageEnd"
                        type="text"
                        required
                        minLength="10"
                        maxLength="10"
                        placeholder="YYYY-MM-DD"
                        onChange={handleDateChange}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="2" style={{ paddingTop: "10px" }}>
                      <button
                        className="saveButton download-round-buttons"
                        onClick={doDownloadUsage}
                        disabled={!datesEntered}
                      >
                        Download Usage Report
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default DownloadUsageReport;
